// extracted by mini-css-extract-plugin
export default {"labelTd":"ThongTinDonvi_labelTd__XWuKH","tr":"ThongTinDonvi_tr__2G0PA"};